import React from 'react';
import { applyStyles } from 'util/helpers';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import Jump from 'components/common/Jump';
import Content from './components/Content';
import About from './components/About';
import i18n from 'i18n';
import Colors from 'constants/colors';
import Breadcrumbs from 'components/common/Breadcrumbs';
import GrayHeader from 'components/common/GrayHeader';

const faq = ({ className, location: { pathname } }) => (
  <div className={className}>
    <GrayHeader text={i18n.t('faq:grayHeader')} />
    <Breadcrumbs currentPath={pathname} />
    <Jump />
    <section>
      <Content />
    </section>
    <section>
      <About />
    </section>
  </div>
);

const commonStyle = css`
  section {
    border-bottom: 1px solid ${Colors.gray2};

    &:last-child {
      border-bottom: none;
      padding-bottom: 20px;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  max-width: 886px;
  margin: 0 auto

  ${Content} {
    margin-top: 44px;
  }

  ${Breadcrumbs} {
    margin-top: 12px;
  }

  section {
    padding-bottom: 72px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 0 16px;

  ${Breadcrumbs} {
    margin-top: 6px;
  }

  ${Content} {
    margin-top: 28px;
  }

  section {
    padding-bottom: 32px;
  }
`;

export default applyStyles(faq)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Faq/index.js